module.exports = __webpack_public_path__ + "img/组 127.9ee5d73c.png";